import { Member } from '@components/members/member.class';
import { differenceInYears } from 'date-fns';

export class DelightedMemberProperties {
  public subscriberId?: string;
  public fullName?: string;
  public gender?: string;
  public dob?: string;
  public age?: number;

  constructor(member: Member) {
    this.subscriberId = member.subscriber_id || null;
    this.fullName = member.full_name || null;
    this.gender = member.gender || null;
    this.dob = member.dob || null;
    this.age = member.dob
      ? differenceInYears(new Date(), new Date(member.dob))
      : null;
  }
}
